// extracted by mini-css-extract-plugin
module.exports = {"outer":"styles_outer__1VADJ","caption":"styles_caption__22lmn"};